/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import classNames from 'classnames';
import React from 'react';

import * as benchlingUtil from 'BenchlingUtil';
import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {capwords} from 'util/NameUtil';

interface Props {
  breadcrumbs: Array<{name: string; url: string}>;
  title?: string;
  isSettingsShown?: boolean;
  onChangeIsSettingsShown?: (...args: Array<any>) => any;
  type?: string;
  onExport?: (...args: Array<any>) => any;
  dataTestAttrs?: DataTestAttrs;
}

function ShowSettingsButton({
  toggleShowSettingsButton,
  isSettingsShown,
  type,
}: {
  toggleShowSettingsButton: () => void;
  isSettingsShown: boolean;
  type?: string;
}): JSX.Element {
  return (
    <Tooltip text={`Manage ${capwords(type)}`}>
      <a
        className={classNames('settingsPage-btn pull-right', {
          'is-active': isSettingsShown,
        })}
        onClick={toggleShowSettingsButton}
      >
        <BenchlingIcon icon="gear" />
      </a>
    </Tooltip>
  );
}

class SettingsPage extends React.Component<Props> {
  static defaultProps = {
    breadcrumbs: [],
  };

  settingsBtnClickHandler = (): void => {
    this.props.onChangeIsSettingsShown!(true);
  };

  breadcrumbClickHandler = (e: any): void => {
    benchlingUtil.navigate(e);
  };

  render(): JSX.Element {
    return (
      <div className="settingsPage" {...getTestProps(this.props.dataTestAttrs)}>
        <div className="settingsPage-contentWrapper">
          {this.props.isSettingsShown != null && (
            <ShowSettingsButton
              type={this.props.type}
              toggleShowSettingsButton={this.settingsBtnClickHandler}
              isSettingsShown={this.props.isSettingsShown}
            />
          )}
          {this.props.onExport && (
            <Tooltip text="Export">
              <a className="settingsPage-btn pull-right" onClick={this.props.onExport}>
                <BenchlingIcon icon="export" />
              </a>
            </Tooltip>
          )}
          <h2 className="settingsPage-header">
            {this.props.breadcrumbs.map(({name, url}) => [
              <a
                className="settingsPage-header-crumb"
                key="name"
                href={url}
                onClick={this.breadcrumbClickHandler}
              >
                {name}
              </a>,
              <BenchlingIcon className="settingsPage-header-chevron" key="chevron" icon="chevron-right" />,
            ])}
            <span className={classNames('settingsPage-header-title', {faded: !this.props.title})}>
              {this.props.title != null ? this.props.title : '...'}
            </span>
          </h2>
          <div className="settingsPage-content">{this.props.children}</div>
        </div>
      </div>
    );
  }
}

export default SettingsPage;
